import { setAutostartTV } from 'actions/autostart-tv';
import { showToast } from 'actions/toast';

export default dispatch => ({
  setAutostartTV: isAutostartTVEnabled => dispatch(setAutostartTV(isAutostartTVEnabled)),
  showToast: data => dispatch(showToast(data)),
});
